import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div style={{
      "paddingTop": "30em"
    }}></div>
    <center>
      <h2>{`About`}</h2>
    </center>
    <p /><img src="https://alfonso-jim.github.io/img/aboutme.JPG" style={{
      "display": "block",
      "maxWidth": "60%",
      "maxHeight": "60%",
      "borderRadius": "8px",
      "marginLeft": "auto",
      "marginRight": "auto"
    }} /><p />
    <div style={{
      "textAlign": "justify",
      "textJustify": "inter-word",
      "paddingBottom": "30em"
    }}>
      <p>{`I am a programmer and tennis player graduated from `}<a href="https://www.concord.edu/">{` Concord University`}</a>{`. I craft enjoyable applications using JS frameworks and experiment with different queries in SQLyog. Currently I work for `}<a href="https://www.pay.nl/">{` PAY.`}</a>{` as a support technitian.`}</p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      